import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gantt-header',
  templateUrl: './gantt-header.component.html',
  styleUrls: ['./gantt-header.component.scss']
})
export class GanttHeaderComponent implements OnInit {

  @Input() title;
  @Input() type;

  constructor() { }

  ngOnInit() {
  }

}
